export default __webpack_public_path__ + "static/media/pic2.f326e70f.jpg";